import React from 'react';

interface StockStatusProps {
  inStock: boolean;
}

export const StockStatus: React.FC<StockStatusProps> = ({ inStock }) => {
  const stockStatusStyles: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    height: 34,
    borderRadius: 24,
    fontSize: 12,
    fontWeight: 500,
    padding: '0 14px'
  };

  if (inStock) {
    return (
      <div
        style={{
          background: '#EAF9DE',
          ...stockStatusStyles
        }}>
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ flexShrink: 0 }}>
          <circle cx="3" cy="3" r="3" fill="#008A00" />
        </svg>
        <span style={{ color: '#008A00', lineHeight: 1 }}>In stock</span>
      </div>
    );
  } else {
    return (
      <div
        style={{
          background: '#ED050514',
          ...stockStatusStyles
        }}>
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ flexShrink: 0 }}>
          <circle cx="3" cy="3" r="3" fill="#ED0505" />
        </svg>
        <span style={{ color: '#ED0505', lineHeight: 1 }}>Out of stock</span>
      </div>
    );
  }
};
